module.exports = __webpack_public_path__ + "static/media/souse-bg.a27818f0.png";